// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { HolderServiceRequest } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Holder';
import { ERR_CAN_HOLDER_SVC, SUC_CAN_HOLDER_SVC } from '../../../../utils/strings';

export const useCancelHolderServiceRequest = () => {
  const { submit } = useExerciseSubmission(
    HolderServiceRequest.HolderServiceRequest_Cancel,
    SUC_CAN_HOLDER_SVC,
    ERR_CAN_HOLDER_SVC,
  );
  return submit;
};
